import {
    SpeakerLoudIcon,
    SpeakerOffIcon,
    SpeakerQuietIcon,
} from '@radix-ui/react-icons';
import { Box, Flex } from '@radix-ui/themes';
import { useMediaRemote, useMediaState, VolumeSlider } from '@vidstack/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PlayerIconButton } from './SmartPlayerUI';
import styles from '../styles/SmartPlayer.module.css';

export const SmartPlayerVolume = () => {
    const { t } = useTranslation('smartPlayer');
    const isMuted = useMediaState('muted');
    const volume = useMediaState('volume');
    const remote = useMediaRemote();
    const [isHovered, setIsHovered] = useState(false);

    const isEffectivelyMuted = isMuted || volume === 0;
    const VolumeIcon = isEffectivelyMuted
        ? SpeakerOffIcon
        : volume < 0.5
          ? SpeakerQuietIcon
          : SpeakerLoudIcon;

    return (
        <Flex
            direction='column'
            align='center'
            onPointerEnter={() => setIsHovered(true)}
            onPointerLeave={() => setIsHovered(false)}
            style={{ position: 'relative' }}
        >
            <Box
                style={{
                    position: 'absolute',
                    bottom: '100%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    paddingBottom: '12px',
                    height: isHovered ? '100px' : '0px',
                    opacity: isHovered ? 1 : 0,
                    pointerEvents: isHovered ? 'auto' : 'none',
                    transition: 'height 0.2s ease, opacity 0.2s ease',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    zIndex: 50,
                }}
            >
                <Box
                    className={styles.solidPanel}
                    style={{
                        padding: '12px 8px',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <VolumeSlider.Root
                        orientation='vertical'
                        style={{
                            width: '16px',
                            height: '64px',
                            display: 'flex',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            position: 'relative',
                        }}
                    >
                        <VolumeSlider.Track
                            style={{
                                width: '4px',
                                height: '100%',
                                backgroundColor: 'var(--gray-a6)',
                                borderRadius: '9999px',
                                position: 'relative',
                            }}
                        >
                            <VolumeSlider.TrackFill
                                style={{
                                    backgroundColor: 'white',
                                    width: '100%',
                                    height: 'var(--slider-fill)',
                                    position: 'absolute',
                                    bottom: 0,
                                    left: 0,
                                    borderRadius: 'inherit',
                                    willChange: 'height',
                                }}
                            />
                        </VolumeSlider.Track>
                        <VolumeSlider.Thumb
                            style={{
                                position: 'absolute',
                                bottom: 'var(--slider-fill)',
                                left: '50%',
                                transform: 'translate(-50%, 50%)',
                                width: '12px',
                                height: '12px',
                                backgroundColor: 'white',
                                borderRadius: '50%',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.5)',
                                willChange: 'bottom',
                            }}
                        />
                    </VolumeSlider.Root>
                </Box>
            </Box>

            <PlayerIconButton
                onClick={() => remote.toggleMuted()}
                title={isMuted ? t('controls.unmute') : t('controls.mute')}
            >
                <VolumeIcon width='18' height='18' />
            </PlayerIconButton>
        </Flex>
    );
};
